export enum CancellationTermsTypeEnum {
    DEFAULT = 'DEFAULT',
    EMPTY_LEG = 'EMPTY_LEG',
    DYNAMIC_DEPARTURE = 'DYNAMIC_DEPARTURE'
}